import { REQUEST, LIST } from '../../../../redux/ActionType';
import { ARCHIVED_JOB_APPLICATIONS } from '../../constants';

export const getArchivedJobApplications = (params) => ({
    type: REQUEST(LIST(ARCHIVED_JOB_APPLICATIONS)),
    payload: { params },
});
